import React from "react";
import { Quote, ArrowUpRight } from "lucide-react";
import { DiamondBorder, SectionLabel } from "./AipanPattern";

const leaders = [
  {
    name: "Dr. Dhal Singh Bisen",
    image: "/images/Governer_img.jpeg",
    // honors: "PVSM, UYSM, AVSM, VSM",
    role: "Hon'ble Chancellor",
    sub: "Governor of Uttarakhand",
    // quote: "An institution is measured by the lives it transforms and the ideas it nurtures. Kumaun University has, for five decades, done both with grace.",
    tone: "pine",
  },
  {
    name: "Shri Pushkar Singh Dhami",
    image: "/images/cm_ku.jpg",
    // honors: "FNASc, FRSC, CChem (London)",
    role: "Hon'ble Chief Minister of Uttarakhand",
    // sub: "Chemist · Educator · Reformer",
    // quote: "From the pine-clad slopes of Nainital to the frontiers of global research — we prepare students not just to succeed, but to serve.",
    tone: "terracotta",
  },
   {
    name: "Dr. Dhan Singh Rawat",
    image: "/images/minister_ku.jpg",
    // honors: "PVSM, UYSM, AVSM, VSM",
    role: "Hon'ble Minister of Higher Education Uttarakhand",
    // sub: "Governor of Uttarakhand",
    // quote: "An institution is measured by the lives it transforms and the ideas it nurtures. Kumaun University has, for five decades, done both with grace.",
     tone: "pine",
  },
  {
    name: "Prof. Satpal Singh Bisht",
    image: "/images/Satya_pal_vc.jpeg",
    // honors: "FNASc, FRSC, CChem (London)",
    role: "Hon'ble Vice-Chancellor",
    // sub: "Chemist · Educator · Reformer",
    // quote: "From the pine-clad slopes of Nainital to the frontiers of global research — we prepare students not just to succeed, but to serve.",
    tone: "terracotta",
  },
];

export default function Leadership() {
  return (
    <></>
//     <section className="py-24 bg-gradient-to-b from-[var(--cream)] to-[var(--paper)] -mt-[140px]">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="text-center">
//           <SectionLabel>Words from the Leadership</SectionLabel>
//           <h2 className="mt-5 font-display text-[38px] lg:text-[48px] font-bold text-[var(--ink)]">
//             Guided by <span className="italic text-[var(--terracotta)]">wisdom</span>. Anchored in the hills.
//           </h2>
//           <DiamondBorder className="my-6 mx-auto max-w-md" />
//         </div>

//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
//   {leaders.map((l) => (
//     <article
//       key={l.name}
//       className={`relative rounded-2xl p-5 shadow-xl overflow-hidden ${
//         l.tone === "pine"
//           ? "bg-gradient-to-br from-[var(--pine-deep)] to-[var(--pine)] text-white"
//           : "bg-gradient-to-br from-[var(--terracotta-deep)] to-[var(--terracotta)] text-white"
//       }`}
//     >
//       <Quote
//         size={38}
//         className="absolute right-4 top-4 opacity-15"
//       />

//       {/* Leader Image */}
//       <div className="h-[105px] w-[105px] rounded-full overflow-hidden border border-white/20 mb-4">
//         <img
//           src={l.image}
//           alt={l.name}
//           className="h-full w-full object-cover"
//         />
//       </div>

//       {/* Quote */}
//       {/* <p className="font-serif italic text-[15px] leading-relaxed line-clamp-4">
//         “{l.quote}”
//       </p> */}

//       {/* Details */}
//       <div className="mt-5 pt-4 border-t border-white/20">
//         <div className="font-display font-bold text-[18px]">
//           {l.name}
//         </div>

//         <div className="text-[10px] tracking-[0.15em] uppercase opacity-80 mt-1">
//           {l.honors}
//         </div>

//         <div className="mt-2 text-[12px] opacity-95">
//           {l.role} ·{" "}
//           <span className="opacity-70">{l.sub}</span>
//         </div>
//       </div>

//       {/* Read More */}
//       {/* <a
//         href="#"
//         className="mt-4 inline-flex items-center gap-1.5 text-[12px] font-semibold opacity-90 hover:opacity-100"
//       >
//         Read full message
//         <ArrowUpRight size={14} />
//       </a> */}
//     </article>
//   ))}
// </div>
//       </div>
//     </section>
  );
}
